import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Téléchargement Instantané', 'Aucun Abonnement', 'Accès à Vie', 'Garantie de 7 Jours'];
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-20 pt-5" data-id="element-107" data-mp="9lbfqzxtf9d2">
      <div className="mx-auto max-w-4xl text-center" data-id="element-108" data-mp="4m8mecr76rkx">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="font-display text-[2.1rem] font-black leading-[1.04] tracking-tight text-ink sm:text-5xl md:text-[3.5rem]" data-id="element-109" data-mp="4jm4pkalevoz">
          Préparez une Année Entière de Cours d&apos;Anglais en seulement{' '}
          <span className="italic text-brand" data-id="element-110" data-mp="nbosrgpkde99">5 Minutes</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-ink/60 sm:text-lg" data-id="element-111" data-mp="3d2bkbqsid1w2">
          Rejoignez plus de 2 000 enseignants : entrez en classe avec tout le
          matériel prêt, de la Primaire au Secondaire.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-2 max-w-2xl pb-5 pt-2.5 sm:mt-8" data-id="element-112" data-mp="39cpcgsselh1u">
          <img src="https://cdn.magicpatterns.com/uploads/oj4vu1ZGic2gAw9jFnmDzD/5da38fdb-3094-4289-914e-47cc7e9f40a3.webp" alt="Le Pack ANGLAIS PRÊT : la collection complète de 12 volumes PDF (5 volumes Primaire et 7 volumes Secondaire) avec la plateforme sur ordinateur, tablette et smartphone" className="mx-auto w-[62%] max-w-xs sm:w-[56%] sm:max-w-sm" data-id="element-113" data-mp="35aatm8oqihak" />
          <p className="mx-auto mt-3 max-w-lg text-xs leading-relaxed text-ink/50 sm:text-sm" data-id="element-114" data-mp="2lk8wcns87z56">
            Le Pack ANGLAIS PRÊT™ : 12 Volumes PDF (5 Primaire + 7 Secondaire)
            et les 5 Bonus Officiels inclus.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} className="-mt-2 sm:mt-8" data-id="element-115" data-mp="iboywmxo6qvf">
          <CtaButton href="#offer" data-id="element-116" data-mp="1azkutpff0er5" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-ink/50 sm:text-sm" data-id="element-117" data-mp="1ayji7gir3k7b">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-118" data-mp="110wqtuk9m06g" data-mpi={index}>
                <span data-id="element-119" data-mp="x0324yz00hci">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-ink/25" data-id="element-120" data-mp="3lt74enpyzlso">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}